import type { AitypesInsight } from '@polaris/api-client'
import Image from 'next/image'
import { cn } from '@/src/utils/styles'

type Variant = 'featured' | 'card' | 'article'

const getImageSizes = (variant?: Variant | null) => {
  switch (variant) {
    case 'card':
      return '104px'
    case 'article':
      return '(max-width: 960px) 100vw, 960px'
    default:
      return '(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 480px'
  }
}

export const InsightCardBackground = ({
  insight,
  variant,
  className,
}: {
  insight: AitypesInsight
  variant?: Variant | null
  className?: string
}) => {
  const bgComponents = {
    image: (
      <>
        <Image
          src={insight.backgroundValue}
          alt='Insight card background'
          fill
          sizes={getImageSizes(variant)}
          className={cn('object-cover absolute inset-0 rounded-xl', className)}
          priority
        />
        <div className={cn('absolute inset-0 rounded-xl', className)} />
      </>
    ),
    color: (
      <div
        className={cn('absolute inset-0 rounded-xl', className)}
        style={{
          backgroundColor: `rgb(var(--${insight.backgroundValue}))`,
        }}
      />
    ),
  }

  return bgComponents[insight.backgroundType]
}
